<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Return Handling</h3>

            <div class="search_bar mb-1">
                <b-card>
                    <b-row class="mb-1">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.route_selected" :options="route_options" />
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.client_selected" :options="client_options" />
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.return_status_selected"
                                :options="return_status_options" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <!-- <strong>Order Date </strong> -->
                            <b-form-input id="input-small" size="sm" type="text" value="Returning Date"
                                :disabled="true"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.returning_date_start_at"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.returning_date_end_at"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
                            <b-form-select size="sm" v-model="search_criteria.returned_date"
                                :options="returned_date_options" />
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.returned_date == 'returned_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.returned_date_start_at"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
                            v-if="search_criteria.returned_date == 'returned_date_yes'">
                            <b-form-input id="input-small" size="sm" type="date"
                                v-model="search_criteria.returned_date_end_at"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col cols="12" sm="12" md="4" class="pl-1 pr-1">
                            <b-form-input id="input-small" size="sm" type="text" placeholder="Order#"
                                v-model="search_criteria.keyword"></b-form-input>
                        </b-col>

                        <b-col class="text-left p-0">
                            <b-button class="btn-action" size="sm" variant="info" @click="onSearch" v-if="checkPermission(
                                $store.state.user_obj,
                                'Order Management',
                                'Order Master',
                                'Search',
                                true
                            )
                                ">
                                <font-awesome-icon class="mr-1" icon="search" />Search
                            </b-button>

                            <b-button class="btn-action" size="sm" variant="info" @click="exportCSV" v-if="checkPermission(
                                $store.state.user_obj,
                                'Order Management',
                                'Order Master',
                                'Export CSV',
                                true
                            )
                                ">Export All</b-button>
                            <b-button class="btn-action" size="sm" variant="info" @click="exportOrderTrackingMaster" v-if="checkPermission(
                                $store.state.user_obj,
                                'Order Management',
                                'Order Master',
                                'Export Order Tracking Master',
                                true
                            )
                                ">Export by Route</b-button>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row>
                        <b-col cols="2" class="pl-1 pr-1">
                            <b-form-input id="input-small" size="sm" type="text" placeholder="Tracking#"
                                v-model="manual_return_tracking_number"
                                v-on:keyup.enter="onManualReturnToWarehouse"></b-form-input>
                        </b-col>
                        <b-col class="text-left p-0">
                            <b-button class="btn-action" size="sm" variant="info"
                                @click="onManualReturnToWarehouse">Returned to Warehouse</b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </div>

            <strong># of Records: {{ total_rows }}</strong>

            <b-row class="mb-1">
                <b-col cols="1" class="pr-0">
                    <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500]"
                        @change="getReturnHandling()" />
                </b-col>
                <b-col class="pl-0 pr-1">
                    <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
                        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
                </b-col>
            </b-row>

            <b-table responsive small outlined striped hover :items="items" :fields="fields" :tbody-tr-class="rowClass">
                <template v-slot:head(chk_box)="data">
                    <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
                </template>
                <template v-slot:cell(chk_box)="data">
                    <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
                        v-model="data.item.is_checked"></b-form-checkbox>
                </template>

                <template v-slot:cell(order_date)="data">
                    {{ displayDate(data.item.order_date) }}
                </template>

                <template v-slot:cell(order_number)="data">
                    <router-link :to="{
                        name: 'order_master_detail',
                        params: { order_master_id: data.item.id },
                    }">
                        {{ data.item.order_number }}
                    </router-link>
                </template>

                <template v-slot:cell(related_orders)="data">
                    <span v-if="data.item.related_orders.length == 0" class="dot_white"></span>

                    <span v-if="data.item.related_orders.length > 0" class="dot_green"></span>
                </template>

                <template v-slot:cell(payment_status)="data">
                    {{ data.item.payment_status || "-" }}
                </template>

                <template v-slot:cell(order_import_status)="data">
                    <div>
                        <span class="span-status">{{ data.item.order_import_status }}</span>

                        <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
                        <span v-if="data.item.order_import_status == 'hold'" class="dot_red"></span>
                        <span v-if="data.item.order_import_status == 'pending'" class="dot_yellow"></span>
                        <span v-if="data.item.order_import_status == 'received'" class="dot_green"></span>
                    </div>
                </template>

                <template v-slot:cell(stock_status)="data">
                    <div>
                        <span class="span-status">{{ data.item.stock_status }}</span>

                        <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
                        <span v-if="data.item.stock_status == 'pending'" class="dot_red"></span>
                        <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
                        <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>
                    </div>
                </template>

                <template v-slot:cell(fulfilment_status)="data">
                    <div>
                        <span class="span-status">{{ data.item.fulfilment_status }}</span>

                        <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
                        <span v-if="data.item.fulfilment_status == 'pending'" class="dot_yellow"></span>
                        <span v-if="data.item.fulfilment_status == 'completed'" class="dot_green"></span>
                        <span v-if="data.item.fulfilment_status == 'fulfiled'" class="dot_green"></span>
                        <span v-if="data.item.fulfilment_status == 'start_picking'" class="dot_yellow"></span>
                        <span v-if="data.item.fulfilment_status == 'cannot_find_inventory'" class="dot_red"></span>
                        <span v-if="data.item.fulfilment_status == 'other_issues'" class="dot_red"></span>
                    </div>
                </template>

                <!-- <template v-slot:cell(delivery_status)="data">
            <div>
              
              <span v-if="data.item.delivery_status == '-'" class="dot_white"></span>
              <span v-if="data.item.delivery_status == 'pending'" class="dot_yellow"></span>
              <span v-if="data.item.delivery_status == 'completed'" class="dot_green"></span>
              <span v-if="data.item.delivery_status == 'fulfiled'" class="dot_green"></span>
  
            </div>
          </template> -->

                <template v-slot:cell(action)="data">
                    <b-button v-if="checkPermission(
                        $store.state.user_obj,
                        'Order Management',
                        'Order Master',
                        'Receive Order',
                        true
                    )" 
                    class="btn-action" size="sm" variant="info"
                    @click="doReceiveOrder(data.item)">Returned To Warehouse</b-button>
                </template>
            </b-table>

            <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
                @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-container>
    </div>
</template>
  
<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";

const fields = [
    {
        key: "chk_box",
        label: "",
    },
    {
        key: "route",
        label: "Route",
    },
    {
        key: "carried_by",
        label: "Driver",
    },
    {
        key: "client_name",
        label: "Client",
    },
    {
        key: "tracking_number",
        label: "Tracking#",
    },
    {
        key: "ctns",
        label: "Ctns"
    },
    {
        key: "scheduled_delivery_date",
        label: "Scheduled Delivery Date",
        class: "txt_camelcase center_align",
    },
    {
        key: "returning_date",
        label: "Returning Date",
        class: "txt_camelcase center_align",
    },
    {
        key: "returned_date",
        label: "Returned Date",
        class: "txt_camelcase center_align",
    },
    {
        key: "action",
        label: "Action",
    },
];

export default {
    name: "OrderMaster",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode,
    },
    data() {
        return {
            sel_table_limit: 100,
            courier_options: [],
            loader_full: false,
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            table_offset: 0,
            total_rows: 0,
            search_criteria: {
                keyword: "",
                route_selected: null,
                client_selected: null,
                return_status_selected: null,
                returning_date_start_at: moment().subtract(6, "months").format("YYYY-MM-DD"),
                returning_date_end_at: moment().format("YYYY-MM-DD"),
                returned_date_start_at: moment().subtract(6, "months").format("YYYY-MM-DD"),
                returned_date_end_at: moment().format("YYYY-MM-DD"),
                returned_date: null,
            },
            showAlert_success: false,
            alert_success_message: "",

            showAlert_error: false,
            alert_error_message: "",
            route_options: [
                {
                    value: null,
                    text: "All Routes",
                },
            ],
            return_status_options: [
                {
                    value: null,
                    text: "All Return Status",
                },
                {
                    value: "Returning_to_warehouse",
                    text: "Returning to Warehouse",
                },
                {
                    value: "Returned_to_warehouse",
                    text: "Returned to Warehouse",
                },
            ],
            manual_return_tracking_number: "",

            client_options: [
                {
                    value: null,
                    text: "All Clients",
                },
            ],

            check_all_rows: false,
            outstanding_order_cnts: {},
            outstanding_stock_cnts: {},
            outstanding_fulfilment_cnts: {},
            bo_cnts: {},

            returned_date_options: [
                {
                    value: null,
                    text: "All Returned Date",
                },
                {
                    value: "returned_date_yes",
                    text: "Returned Date",
                },
                {
                    value: "returned_date_no",
                    text: "NO Returned Date",
                },
            ],

            collection_date_options: [
                {
                    value: null,
                    text: "All Collection Date",
                },
                {
                    value: "collection_date_yes",
                    text: "Collection Date",
                },
                {
                    value: "collection_date_no",
                    text: "NO Collection Date",
                },
            ],
        };
    },
    async created() {
        await this.getReturnHandling();

        let clients_response = await this.getClients(this.$store.state.user_obj);
        for (let i in clients_response.clients) {
            this.client_options.push({
                value: clients_response.clients[i].id,
                text: clients_response.clients[i].full_name,
            });
        }

        this.initialized = true;
    },
    mounted() {
        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false,
        });
    },
    watch: {
        // whenever changes, this function will run
        check_all_rows: function (new_val, old_val) {
            // this.check_all_rows = !this.check_all_rows;
            console.log("check_all_rows");
            if (new_val == "all") {
                // Check all
                for (let i in this.items) {
                    this.items[i].is_checked = true;
                }
            } else {
                for (let i in this.items) {
                    this.items[i].is_checked = false;
                }
            }
            console.log(this.items);
        },
    },
    methods: {

        displayDate(d) {
            if (d) {
                return moment(d).format("YYYY-MM-DD");
            } else {
                return "/";
            }
        },

        async getReturnHandling() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "return_handling_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.sel_table_limit,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });
            this.items = response.data.trackings;
            this.total_rows = parseInt(response.data.total_rows);
            this.loader.hide();
        },

        onSearch() {
            this.getReturnHandling();
        },

        onPageChange(page_to_change) {
            this.table_offset = (page_to_change - 1) * this.sel_table_limit;
            this.getReturnHandling();
        },

        async onBulkAction(bulk_action) {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            let order_master_ids = [];
            for (let i in this.items) {
                if (this.items[i].is_checked) {
                    order_master_ids.push(this.items[i].id);
                }
            }

            // call action
            let action_urls = {
                receive: "order_master_receive.php",
                commit: "order_master_commit.php",
                fulfill: "order_master_fulfil.php",
            };

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: action_urls[bulk_action],
                data: {
                    order_master_ids: order_master_ids,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
            });

            this.loader_full.hide();
            if (bulk_action == 'commit') {
                if (response.data.status === "success") {
                    this.$eventHub.$emit("show_alert_message", {
                        alert_message: "Commit Order Success",
                        variant: "success",
                    });
                } else {
                    this.$eventHub.$emit("show_modal_message", {
                        message_content: response.data.error || "Cancel Order Failed",
                        variant: "danger"
                    });
                }
            } else {
                this.$eventHub.$emit("show_alert_message", {
                    alert_message: "Bulk Update Success",
                    variant: "success",
                });
            }

            this.getReturnHandling();
        },

        rowClass(item, type) {
            if (!item || type !== "row") return;
            if (item.is_checked) return "table-info";
        },

        onManualReturnToWarehouse() {
            this.updateTracking(
                {
                    id: this.manual_return_tracking_number,
                    tracking_number: this.manual_return_tracking_number,
                    by_tracking_number: true,
                },
                "Returned_to_Warehouse",
                null,
                null
            );
        },
    },
};
</script>
  
<style>
th,
td {
    white-space: nowrap;
}

.span-status {
    display: none;
}

.container-status:hover .span-status {
    display: inline;
}

.row-status_cnt {
    display: flex;
}
</style>
  


// WEBPACK FOOTER //
// src/components/ReturnHandling.vue